export enum SelfReferralCTAStyle {
  INITIAL = 'initial',
  COLOR_AND_ICON_UPDATE = 'color-and-icon-update'
}
